import React from 'react';
import { Navigate } from 'react-router-dom';
import { InitiativesDB } from '../../utils/initiativesData';

/**
 * Renders children only when Strategic Initiatives feature is enabled for the current role.
 * Otherwise redirects to home.
 */
export default function StrategicInitiativesGate({ currentRole, children }) {
  if (!InitiativesDB.isFeatureEnabled(currentRole)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
